import React from "react";
import { Banner } from "ui/Banner";
import useHashConnect from "hooks/useHashConnect";
import { getMaintainanceMessage } from "utils";

interface BannerWrapperProps {
  closeBanner: () => void;
}

function BannerWrapper({ closeBanner }: BannerWrapperProps) {
  const { maintainanceData, firestoreData } = useHashConnect();

  return (
    <Banner
      text={
        maintainanceData?.isActive
          ? getMaintainanceMessage(maintainanceData)
          : firestoreData?.bannerText
      }
      closeBanner={closeBanner}
      showIcon={false}
      bg={
        maintainanceData?.isActive
          ? "brand.banner.dangerBackground"
          : "brand.banner.background"
      }
      color="brand.banner.text"
      fontFamily="Arial"
    />
  );
}

export default BannerWrapper;
